// extracted by mini-css-extract-plugin
export default {"shopDetails":"ShopDetails_shopDetails__soAlp","shopDetailCardContainer":"ShopDetails_shopDetailCardContainer__d4rfL","shopDetailCard":"ShopDetails_shopDetailCard__C+fp7"};